import { PublicClientApplication } from "@azure/msal-browser";
import { MSCLIENT_ID, REDIRECTURL, TENANT_ID } from "./config";

export const msalConfig = {
  auth: {
    clientId: MSCLIENT_ID,
    //authority: "https://login.microsoftonline.com/common", 
    authority: "https://login.microsoftonline.com/" + TENANT_ID,
    redirectUri: REDIRECTURL,  // same as Azure
  }
};



export const msalInstance = new PublicClientApplication(msalConfig);
